/* eslint-disable @typescript-eslint/dot-notation */
import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import * as Sentry from '@sentry/angular-ivy'
import { Integrations } from '@sentry/tracing'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { initializeAnalytics } from './app/utils/initialize-analytics'
import { AppComponent } from './app/app.component'
import { appConfig, keycloakConfig, keycloakService } from './app/app.config'

type GlobalWithRemoteConfig = typeof globalThis & {
  ef: {
    remoteConfig: {
      configuration: CustomerPortalConfig
    }
  }
}

const remoteConfig = (globalThis as GlobalWithRemoteConfig).ef.remoteConfig
  .configuration

if (remoteConfig.production) {
  enableProdMode()
}

keycloakService
  .init(keycloakConfig)
  .then(() => {
    void bootstrapApplication(AppComponent, appConfig)
      // eslint-disable-next-line no-console
      .catch(err => { console.error(err) })
  })
  .catch(error => {
    // eslint-disable-next-line no-console
    console.error('[bootstrap] init Keycloak failed', error)
  })

initializeAnalytics(remoteConfig)

// Sentry
Sentry.init({
  debug: false,
  dsn: remoteConfig['sentry.dsn'],
  environment: remoteConfig.environmentName,
  ignoreErrors: ['Non-Error exception captured'],
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: remoteConfig['sentry.performanceTracing.tracingOrigins'],
      routingInstrumentation: Sentry.routingInstrumentation
    })
  ],
  tracesSampleRate: remoteConfig['sentry.tracesSampleRate']
})
